var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgICloudKeychain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m217.36,90.69c-15.58,9.54-25.17,26.41-25.38,44.68.06,20.67,12.43,39.32,31.46,47.41-3.67,11.84-9.1,23.06-16.11,33.28-10.03,14.44-20.52,28.87-36.47,28.87s-20.06-9.27-38.45-9.27-24.32,9.57-38.9,9.57-24.77-13.37-36.47-29.79c-15.46-22.99-23.95-49.96-24.47-77.66,0-45.59,29.63-69.75,58.81-69.75,15.5,0,28.42,10.18,38.15,10.18s23.71-10.79,41.34-10.79c18.41-.47,35.84,8.24,46.5,23.25Zm-54.86-42.55c7.77-9.14,12.17-20.67,12.46-32.67.01-1.58-.14-3.16-.46-4.71-13.35,1.3-25.69,7.67-34.5,17.78-7.85,8.78-12.41,20-12.92,31.76,0,1.43.16,2.86.46,4.26,1.05.2,2.12.3,3.19.3,12.43-.99,23.91-7.04,31.76-16.73Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICloudKeychain);
export default __webpack_public_path__ + "static/media/iCloudKeychain.1e6ea6995a2fe2fca5d15466adcbe9fe.svg";
export { ForwardRef as ReactComponent };